import React from "react";

export default (props) => {
    return (
        <div className={'title'}>
            <img alt="logo" src={props.logo.url} width={props.logo.width} height={props.logo.height}/>
        </div>
    );
}
